import getAmountPaid from "./getAmountPaid";

export default function getRefundAmount(order) {
  if (order.total < 0) return order.total

  const paid = getAmountPaid(order)
  if (paid < order.total) return 0
  return paid - order.total
}